<template lang="pug">
.items
  Spinner(v-if="(products && products.loading) || loading" :size="16" :thickness="3")
  ul(ref="list")
    li.item(
      v-for="(item, i) in items"
      :class="{'is-active': currentProduct && item.id === currentProduct.id}"
    )
      ProductPreview(
        :key="item.id"
        :product="item"
        :active="currentProduct && item.id === currentProduct.id"
        :display="displaySetting"
        @got-articles="articles => setArticles(i, articles)"
      )
      //- Matrix(:item="item")
  Pagination(
    v-if="pageInfo && pageInfo.lastPage > 1"
    :last-page="pageInfo.lastPage"
    :current-page="pageInfo.currentPage"
    nav-class="pagination is-rounded is-centered"
    @change="changePage"
  )
    template(v-slot:prev)
      span.icon
        i.fas.fa-arrow-left
    template(v-slot:next)
      span.icon
        i.fas.fa-arrow-right
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import router from '@/router';
import { get, cloneDeep } from '@/helpers';

// import Matrix from './Partials/Matrix';
import ProductPreview from './Partials/ProductPreview';
import Pagination from '@/components/Pagination';

export default {
    name: 'ProductList',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        loading: false,
        currentPage: 1,
        products: undefined
    }),
    components: {
        // Matrix,
        ProductPreview,
        Pagination
    },
    watch: {
        '$route.query'(query) {
            window.scrollTo(0, 0);
            this.currentPage = get(query, `P${this.section.id}`) || 1;
            this.refetch();
        }
    },
    computed: {
        pageInfo() {
            return get(this.products, 'pageInfo');
        },
        items() {
            return get(this.products, 'items') || [];
        },
        displaySetting() {
            let display = 'rows';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'display');
                if (setting && setting.value !== undefined) display = setting.value;
            }

            return display;
        },
        currentProduct() {
            if (this.focusedMedia && this.focusedMedia.product) return this.focusedMedia.product;
            return this.activeProduct;
        },
        ...mapGetters({
            // products: 'shop/products',
            sections: 'sections',
            menus: 'menus',
            member: 'auth/member',
            activeProduct: 'shop/activeProduct',
            focusedMedia: 'shop/focusedMedia',
            cms: 'CMS'
        })
    },
    methods: {
        setArticles(i, articles) {
            const item = { ...{ articles }, ...this.products.items[i] };
            this.$set(this.products.items, i, Object.freeze(item));
        },
        changePage(currentPage) {
            if (this.$refs.list) {
                this.$refs.list.scrollIntoView({
                    behavior: 'smooth'
                });
            }

            if (currentPage > 1) {
                let query = {};
                query[`P${this.section.id}`] = currentPage;
                router.push({ query });
            } else {
                router.push({ query: null });
            }

            this.clearVisibleProducts();
            this.removeFocusedMedia();

            this.currentPage = currentPage;
            this.refetch();
        },
        refetch() {
            this.loading = true;

            const shop = get(this.cms, 'shop.id');
            let categories = [];

            let c = undefined;
            if ((c = get(this.section, 'shopCategories'))) {
                categories = c.map(category => category.id);
            }

            const payload = {
                pageInfo: {
                    currentPage: this.currentPage,
                    perPage: 6
                },
                filters: [
                    {
                        key: 'shop',
                        match: shop.toString()
                    },
                    {
                        key: 'status',
                        match: 'enabled'
                    },
                    {
                        key: 'categories',
                        in: categories
                    },
                    {
                        key: 'qty_sum',
                        from: 1
                    }
                ],
                order: 'date' // property:groupsort
            };
            this.fetchProducts(payload).then(response => {
                const products = cloneDeep(response);
                const container = document.querySelector('.preorder-columns > .column.left > .ps');
                if (container) container.scrollTop = 0;

                if (products.items && products.items.length) {
                    products.items.forEach((product, i) => {
                        product.position = i + 1;
                    });
                }

                this.products = products;
                // this.insertProducts({ products });
                this.loading = false;
            });
        },
        ...mapMutations({
            // updateTeasersLoading: 'updateCategoryPostTeasersLoading',
            // insertProducts: 'shop/insertProducts',
            changeActiveProduct: 'shop/setActiveProduct',
            clearVisibleProducts: 'shop/clearVisibleProducts',
            removeFocusedMedia: 'shop/removeFocusedMedia'
        }),
        ...mapActions({
            fetchProducts: 'shop/fetchProductsPaginated',
            fetchAuthenticatedMember: 'auth/fetchAuthenticatedMember'
        })
    },
    mounted() {
        const products = { loading: true, pagination: {} };
        this.products = products;
        // this.insertProducts({ products });

        this.currentPage = get(this.$route, `query.P${this.section.id}`) || 1;
        // this.currentPage = 1;
        this.refetch();
    }
};
</script>

<style lang="sass">
.items
  position: relative
  min-height: 200px
.spacer
  height: 50px
.item + .item .product-preview
  padding-top: 6rem
  @screen lg
    padding-top: 4rem
    &::v-deep
      .arriw-container
        top: 4rem
.item.is-active .arrow-container
  opacity: 1
.pagination-container
  margin-top: 50px
</style>
